var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 38C8.50659 38 0 29.4934 0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38ZM15.9924 14.491C15.1438 13.7839 15.0292 12.5227 15.7363 11.6742C16.4434 10.8256 17.7045 10.711 18.5531 11.4181L21.7165 14.0543C25.0748 16.8528 25.0748 22.0108 21.7165 24.8094L18.5531 27.4455C17.7045 28.1527 16.4434 28.038 15.7363 27.1895C15.0292 26.3409 15.1438 25.0798 15.9924 24.3726L19.1558 21.7365C20.595 20.5371 20.595 18.3265 19.1558 17.1272L15.9924 14.491Z",
    fill: "#456173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b0a7874765883f5a288b175f0e9c1101.svg";
export { ForwardRef as ReactComponent };